import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { openModal } from '../../redux/modal';
import { themes, textStyles } from '../../styles/styleGuide';
import { fromBreakpoint } from '../../styles/breakpoints';
import Caret from './../shared/icons/Caret';
import Check from './../shared/icons/Check';
var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    openInterestModal: function openInterestModal(hotspotId) {
      dispatch(openModal(themes[ownProps.theme].secondary, {
        type: 'interests',
        componentProps: {
          color: themes[ownProps.theme].primary,
          hotspotId: hotspotId
        }
      }));
    }
  };
};
var ECWSpaceBlockHotspotOptions = /*#__PURE__*/function (_Component) {
  function ECWSpaceBlockHotspotOptions() {
    var _this;
    _classCallCheck(this, ECWSpaceBlockHotspotOptions);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ECWSpaceBlockHotspotOptions, [].concat(args));
    _defineProperty(_this, "containerRef", null);
    return _this;
  }
  _inherits(ECWSpaceBlockHotspotOptions, _Component);
  return _createClass(ECWSpaceBlockHotspotOptions, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.containerRef) {
        this.props.onMeasureHeight(this.containerRef.offsetHeight);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        show = _this$props.show,
        index = _this$props.index,
        theme = _this$props.theme,
        _this$props$options = _this$props.options,
        options = _this$props$options === void 0 ? [] : _this$props$options,
        openInterestModal = _this$props.openInterestModal;
      return __jsx(Container, {
        ref: function ref(el) {
          _this2.containerRef = el;
        },
        show: show,
        color: themes[theme].secondary,
        index: index,
        "data-id": "dashboard_ECWSpaceBlockHotspotOptions_Container"
      }, __jsx(InnerContainer, {
        "data-id": "dashboard_ECWSpaceBlockHotspotOptions_InnerContainer"
      }, (options || []).map(function (hotspot, index) {
        return __jsx(Fold, {
          key: index,
          onClick: function onClick() {
            return openInterestModal(hotspot.id);
          },
          "data-id": "dashboard_ECWSpaceBlockHotspotOptions_Fold"
        }, __jsx(Circle, {
          color: hotspot.hasRating ? themes[theme].active : themes[theme].primary,
          "data-id": "dashboard_ECWSpaceBlockHotspotOptions_Circle"
        }, hotspot.hasRating && __jsx(Check, {
          color: "white",
          width: 9,
          height: 7,
          "data-id": "dashboard_ECWSpaceBlockHotspotOptions_Check"
        })), __jsx(HotspotTitle, {
          "data-id": "dashboard_ECWSpaceBlockHotspotOptions_HotspotTitle"
        }, hotspot.title), __jsx(Caret, {
          color: "white",
          direction: "right",
          width: 8,
          height: 13,
          "data-id": "dashboard_ECWSpaceBlockHotspotOptions_Caret"
        }));
      })));
    }
  }]);
}(Component);
export default connect(null, mapDispatchToProps)(ECWSpaceBlockHotspotOptions);
var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n  position: absolute;\n  top: ", "rem;\n  z-index: 2;\n  width: 290rem;\n  opacity: ", ";\n  transition: max-height 0.3s ease-in-out, top 0.3s ease-in-out;\n  overflow: hidden;\n  ", ";\n"])), function (props) {
  return props.color;
}, function (props) {
  return props.show ? 220 : 200;
}, function (props) {
  return props.show ? 1 : 0;
}, fromBreakpoint.md(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    width: 600rem;\n    right: ", ";\n  "])), function (props) {
  return props.index % 2 === 1 ? 0 : undefined;
}));
var InnerContainer = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding: 24rem 40rem 24rem 0rem;\n  box-sizing: border-box;\n\n  ", ";\n"])), fromBreakpoint.md(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    flex-flow: wrap;\n  "]))));
var Fold = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  margin-bottom: 16rem;\n  cursor: pointer;\n  width: 100%;\n  ", ";\n"])), fromBreakpoint.md(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    width: 50%;\n  "]))));
var Circle = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  width: 18rem;\n  height: 18rem;\n  border-radius: 50%;\n  background-color: ", ";\n  align-items: center;\n  margin-right: 8rem;\n  margin-left: 40rem;\n"])), function (props) {
  return props.color;
});
var HotspotTitle = styled.p(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  ", ";\n  display: inline;\n  color: white;\n  font-weight: bold;\n  margin: 0 5rem 0 0;\n"])), textStyles.standardText);